import React from "react";
import { getCurrentReferenceUnitValue } from "features/MappingEditor/utils";
import { useTranslation } from "react-i18next";
import { ComponentDetailsByFileOut } from "api-client";
import clsx from "clsx";
import ComponentChildContent from "./ComponentChildContent";

const ComponentChildOverview = ({
  childItem,
  referenceUnit,
  hideInfoIcon,
  order,
  showOrder,
}: {
  childItem: ComponentDetailsByFileOut;
  referenceUnit?: string;
  hideInfoIcon?: boolean;
  order?: number;
  showOrder?: boolean;
}) => {
  const { i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const itemReferenceUnit = getCurrentReferenceUnitValue(
    childItem.reference_unit.toUpperCase()
  );

  return (
    <div
      className={clsx(
        "border border-gray-300 rounded-md overflow-hidden flex items-stretch w-full mb-3"
      )}
    >
      <div
        className={clsx(
          "border-r border-gray-200 bg-gray-50 text-gray-500 min-w-[92px]",
          "items-center justify-center flex flex-col text-sm align-middle text-center"
        )}
      >
        <span className="text-gray-900 font-semibold mr-1">
          {childItem?.unit_conversion}
        </span>
        <span className="text-gray-500">
          {`${
            isEng
              ? itemReferenceUnit?.name ?? "-"
              : itemReferenceUnit?.name_de ?? "-"
          }/${referenceUnit}`}
        </span>
      </div>
      <div className="bg-white text-gray-700 text-sm overflow-hidden relative w-full">
        <ComponentChildContent
          childItem={childItem}
          className="!p-0"
          hideInfoIcon={hideInfoIcon}
          order={order}
          showOrder={showOrder}
        />
        {childItem.comment ? (
          <div className="p-3 break-all border-t border-gray-100">
            {childItem.comment}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ComponentChildOverview;
